<script >
import ChartingLeftDrawerFavoritesSection from '@/features/charting-next/components/workspace/left-drawer/ChartingLeftDrawerFavoritesSection.vue';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  entryType: {
    type: String,
    default: 'finder'
  },
  entryValue: {
    type: String,
    default: ''
  },
  favoriteFolders: {
    type: Array,
    default: () => []
  },
  canUseFavorites: {
    type: Boolean,
    default: false
  },
  canManageFavoriteFolders: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const closeDialog = () => emit('update:visible', false);
  const openSource = payload => {
    emit('open-source', payload);
    closeDialog();
  };
  return {
    emit,
    openSource
  };
};
__sfc_main.components = Object.assign({
  ChartingLeftDrawerFavoritesSection
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <Dialog
        :visible="visible"
        modal
        dismissableMask
        closeOnEscape
        mask-class="charting-mobile-fullscreen-mask"
        dialog-class="charting-mobile-fullscreen-dialog"
        :dialog-style="{ width: 'calc(100vw - 2rem)', maxWidth: '40rem' }"
        @update:visible="emit('update:visible', $event)"
    >
        <template #header>
            <div class="text-lg font-semibold">Workspaces</div>
        </template>

        <div class="charting-workspace-dialog-shell">
            <div class="charting-workspace-dialog-grid">
                <div class="charting-workspace-dialog-column">
                    <ChartingLeftDrawerFavoritesSection
                        :favorite-folders="favoriteFolders"
                        :entry-type="entryType"
                        :entry-value="entryValue"
                        :can-use-favorites="canUseFavorites"
                        :can-manage-favorite-folders="canManageFavoriteFolders"
                        @open-source="openSource"
                        @create-favorite-folder="emit('create-favorite-folder', $event)"
                        @rename-favorite-folder="emit('rename-favorite-folder', $event)"
                        @remove-favorite-folder="emit('remove-favorite-folder', $event)"
                    />
                </div>

            </div>
        </div>
    </Dialog>
</template>

<style scoped>
.charting-workspace-dialog-shell {
    display: flex;
    min-height: 0;
    flex-direction: column;
    gap: 1rem;
}

.charting-workspace-dialog-grid {
    display: grid;
    min-height: 0;
    flex: 1 1 auto;
    gap: 1rem;
    grid-template-columns: minmax(0, 1fr);
}

.charting-workspace-dialog-column {
    display: flex;
    min-height: 0;
    flex-direction: column;
    gap: 1rem;
}

.charting-workspace-dialog-shell ::v-deep .charting-workspace-drawer-section {
    border: 0;
    border-radius: 0;
    padding: 0;
    background: transparent;
}

.charting-workspace-dialog-shell ::v-deep .charting-workspace-drawer-section + .charting-workspace-drawer-section {
    border-top: 1px solid var(--charting-b-border-color);
    padding-top: 1rem;
}

@media (max-width: 1023px) {
    .charting-workspace-dialog-shell {
        max-height: none;
    }

    .charting-workspace-dialog-grid {
        grid-template-columns: 1fr;
    }

    .charting-workspace-dialog-column {
        overflow: visible;
        padding-right: 0;
    }
}
</style>
